(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = [...document.querySelectorAll('[data-rb-landing-video]')];
  if (!videos.length) return;
  function allowed() {
    const content = document.getElementById('rb-age-content');
    return !reduced.matches && !navigator.connection?.saveData && !document.hidden && (!content || (!content.hidden && !content.inert));
  }
  function update() {
    videos.forEach(video => {
      if (!allowed()) { video.pause(); return; }
      if (!video.hasAttribute('src')) {
        video.muted = true;
        video.defaultMuted = true;
        const src = window.matchMedia('(max-width: 749px)').matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        if (!src) return;
        video.src = src;
      }
      video.play()?.catch(() => {});
    });
  }
  reduced.addEventListener('change', update);
  document.addEventListener('rb:age-accepted', update);
  document.addEventListener('visibilitychange', update);
  update();
})();
